// extracted by mini-css-extract-plugin
export default {"loginDisclaimer":"LoginDisclaimer_loginDisclaimer__RfEAj"};